import Controller from '@ember/controller';
import { action, computed } from '@ember/object';
import { inject as service } from '@ember/service';
import { EMBER_ROUTE_NAMES } from 'sh-www/constants/routes';

const applicationIncludes = ['thread'];
const pitchIncludes = ['thread', 'application'];

/** @module */
class PostingApplyController extends Controller {
  /** @type {Ember.Service} */
  @service('state-managers/application') applicationStateManager;
  @service('commands/application-commands') applicationCommandService;
  @service('commands/location-commands') locationCommandService;
  @service('commands/pitch-commands') pitchCommandService;
  @service router;

  /** @type {boolean} */
  @computed('model.type')
  get forHire() {
    return this.model.type === 1;
  }

  /**
   * @param {Object} params
   * @param {Object} params.assignmentQuestionResponses
   * @return {Promise<*>}
   */
  @action
  submitApplication({ questionIdToResponseMap }) {
    const {
      model: assignment,
    } = this;

    const form = {
      assignment_question_responses: questionIdToResponseMap,
    };

    return this.applicationCommandService.createApplication(assignment, form, applicationIncludes).then(({ id }) => {
      this.applicationStateManager.addToast('Application sent. Posting moved to Applications.');
      this.router.transitionTo(EMBER_ROUTE_NAMES.POSTING__APP, assignment.slug, id);
    });
  }

  /**
   * @param {Object} params
   * @return {Promise<*>}
   */
  @action
  submitPitch({
    questionIdToResponseMap: assignment_question_responses,
    headline,
    location,
    summary,
    characters,
    produced,
    production_link,
  }) {
    const {
      model: assignment,
      pitchCommandService,
    } = this;

    return pitchCommandService.createPitch(
      assignment,
      {
        assignment_question_responses,
        headline,
        summary,
        characters,
        produced,
        production_link,
        location_id: location?.id,
      },
      pitchIncludes
    )
    .then((pitch) => {
      this.applicationStateManager.addToast('Application sent. Posting moved to Applications.');
      this.router.transitionTo(EMBER_ROUTE_NAMES.POSTING__APP, assignment.slug, pitch.applicationId);
    });
  }
}

export default PostingApplyController;
